import { LegalDoc } from "../components/LegalDoc";

const SECTIONS = [
  {
    heading: "1. Oggetto del servizio",
    paragraphs: [
      "ARCANA offre letture simboliche interattive con le carte (Sibille, Piacentine) e con la Geomanzia, oltre alla possibilità di prenotare consulenze personali con Virginia, cartomante professionista.",
      "L'utilizzo del servizio implica l'accettazione integrale dei presenti Termini e Condizioni.",
    ],
  },
  {
    heading: "2. Natura del servizio",
    paragraphs: [
      "Le letture hanno finalità di intrattenimento, riflessione personale e orientamento simbolico. Le interpretazioni sono generate con l'assistenza di un sistema di intelligenza artificiale, sulla base del metodo personale e professionale di Virginia.",
      "Il servizio non costituisce in alcun caso consulenza professionale di tipo medico, psicologico, legale o finanziario.",
    ],
  },
  {
    heading: "3. Nessuna predizione garantita",
    paragraphs: [
      "Nessun contenuto del servizio costituisce un fatto accertato, una certezza o una previsione garantita di eventi futuri. Le indicazioni temporali e le interpretazioni offerte hanno natura esclusivamente simbolica e indicativa.",
      "Le decisioni che prendi dopo una lettura restano interamente sotto la tua responsabilità.",
    ],
  },
  {
    heading: "4. Contenuti generati dall'intelligenza artificiale",
    paragraphs: [
      "Le interpretazioni sono prodotte automaticamente da un sistema di intelligenza artificiale e, pur essendo curate nel metodo, possono contenere imprecisioni. Ti invitiamo a valutarle con senso critico, come spunto di riflessione e non come verità oggettiva.",
    ],
  },
  {
    heading: "5. Requisiti di utilizzo",
    items: [
      "Il servizio è riservato a persone maggiorenni (18+).",
      "In fase di registrazione ti impegni a fornire dati veritieri e a custodire con cura le tue credenziali di accesso.",
      "Sei responsabile delle attività svolte tramite il tuo account.",
    ],
  },
  {
    heading: "6. Uso accettabile",
    paragraphs: ["È vietato:"],
    items: [
      "utilizzare il servizio in modo automatizzato o mediante strumenti che aggirino i limiti tecnici;",
      "tentare di estrarre, copiare o ottenere i testi riservati del metodo, i significati interni delle carte o le istruzioni del sistema;",
      "utilizzare il servizio per scopi illeciti o per trattare dati di terzi senza autorizzazione;",
      "compiere azioni che compromettano la sicurezza o la disponibilità del servizio.",
    ],
    paragraphs: ["Il servizio applica limiti tecnici anti-abuso; il loro superamento può comportare la sospensione dell'accesso."],
  },
  {
    heading: "7. Proprietà intellettuale",
    paragraphs: [
      "Il metodo interpretativo, i significati delle carte, i testi, la grafica e tutti i contenuti dell'applicazione sono di titolarità esclusiva di Virginia. È vietata qualsiasi riproduzione, anche parziale, senza autorizzazione scritta.",
    ],
  },
  {
    heading: "8. Prenotazioni e consulenze",
    paragraphs: [
      "Le consulenze personali si prenotano tramite l'apposita sezione, nei limiti della disponibilità indicata. La conferma, la modifica o l'annullamento di un appuntamento sono gestiti attraverso il servizio o contattando direttamente Virginia.",
    ],
  },
  {
    heading: "9. Disponibilità del servizio",
    paragraphs: [
      "Il servizio è fornito \"così com'è\": non garantiamo disponibilità continua e possiamo sospenderlo o modificarlo per manutenzione o aggiornamenti, anche senza preavviso.",
    ],
  },
  {
    heading: "10. Limitazione di responsabilità",
    paragraphs: [
      "Nei limiti consentiti dalla legge, il titolare non risponde delle decisioni assunte dagli utenti sulla base delle letture, né di eventuali danni derivanti dall'uso o dall'impossibilità di uso del servizio.",
    ],
  },
  {
    heading: "11. Sospensione ed eliminazione dell'account",
    paragraphs: [
      "Il titolare si riserva il diritto di sospendere temporaneamente o disattivare un account in caso di abuso del servizio, spam, utilizzo manifestamente estraneo alle finalità del servizio, violazione dei presenti termini o tentativi di aggirare i limiti di utilizzo previsti dal proprio piano. Durante la sospensione l'account non può accedere al servizio; i dati restano conservati e la sospensione è reversibile.",
      "Nei casi più gravi o reiterati, il titolare può procedere all'eliminazione definitiva dell'account, con cancellazione di tutti i contenuti associati. I record fiscali degli eventuali pagamenti sono conservati per il periodo previsto dagli obblighi di legge, ove possibile in forma anonimizzata.",
      "La registrazione multipla di account fittizi finalizzata a ottenere ripetutamente il periodo di prova gratuita costituisce abuso del servizio.",
    ],
  },
  {
    heading: "12. Legge applicabile e contatti",
    paragraphs: [
      "I presenti Termini sono regolati dalla legge italiana. Per qualsiasi questione relativa al servizio puoi scrivere a Virgispine@hotmail.it.",
      "Il titolare può aggiornare i Termini in qualsiasi momento: la versione vigente è sempre quella pubblicata in questa pagina.",
    ],
  },
];

export default function Termini() {
  return <LegalDoc title="Termini e Condizioni" tagline="Condizioni di utilizzo del servizio" updated="5 ottobre 2026" sections={SECTIONS} testid="termini-page" />;
}
